
class ConfirmationDialog extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      dialog: this.querySelector('dialog'),
      dialogMessage: this.querySelector('[data-message]'),
      okButton: this.querySelector('button[name=cancel]'),
      cancelButton: this.querySelector('button[name=continue]')
    };
  }

  connectedCallback() {
    // Set up event listeners for buttons
    this.elements.okButton.addEventListener('click', () => this.close(true));
    this.elements.cancelButton.addEventListener('click', () => this.close(false));
  }

  show(message = "Are you sure you want to continue") {
    this.elements.dialogMessage.innerHTML = message;
    this.elements.dialog.showModal();
  }

  close(shouldProceed) {
    this.elements.dialog.close();
    this.dispatchEvent(new CustomEvent('dialog-result', {
      detail: shouldProceed,
      bubbles: true,
      composed: true
    }));
  }
}

// Define the custom element
customElements.define('confirmation-dialog', ConfirmationDialog);